'use client'

import { useEffect, useState } from 'react'
import { getNotificationDetail } from '@/lib/api/notification'
import { inboxAnalytics, toInboxNotificationType, toInboxTabType } from '@/lib/utils/analytics'
import { useNotificationStore } from '@/store/notificationStore'

export function useNotificationDetail(notificationId: string | null | undefined) {
  const refreshUnread = useNotificationStore((state) => state.refreshUnread)
  const [detailMd, setDetailMd] = useState('')
  const [loading, setLoading] = useState(Boolean(notificationId))

  useEffect(() => {
    if (!notificationId) {
      setDetailMd('')
      setLoading(false)
      return
    }

    const controller = new AbortController()
    setLoading(true)
    setDetailMd('')

    void getNotificationDetail(notificationId, controller.signal)
      .then((response) => {
        if (controller.signal.aborted) return
        if (response.code !== 200 || !response.data) {
          setDetailMd('')
          return
        }

        const detail = response.data
        setDetailMd(detail.detailMd ?? '')
        inboxAnalytics.messageViewed(
          toInboxTabType(detail.tab),
          toInboxNotificationType(detail.bizType),
        )
      })
      .catch((error) => {
        if (!controller.signal.aborted) {
          console.error('Failed to load notification detail:', error)
          setDetailMd('')
        }
      })
      .finally(() => {
        if (!controller.signal.aborted) {
          setLoading(false)
          void refreshUnread().catch((error) =>
            console.error('Failed to refresh notification unread state:', error),
          )
        }
      })

    return () => controller.abort()
  }, [notificationId, refreshUnread])

  return { detailMd, loading }
}
